import { useEffect } from "react";
export var ErrorLoading = function ErrorLoading() {
  useEffect(function () {
    window.location.assign("/404?from=".concat(encodeURIComponent(location.href.replace(location.origin, ""))));
  }, []);
  return null;
};